<template>
  <div class="meta">
    <span
      v-if="$slots.freeCancel"
      class="info free-cancel"
    >
      <span :class="['icon', 'icon-check']" />
      <slot name="freeCancel" />
    </span>
    <br>
    <span
      v-if="$slots.tax"
      class="info tax"
    >
      <slot name="tax" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'Meta',
};
</script>

<style lang="scss" scoped>
  .info {
    font-size: 10px;
    line-height: .91;
    display: inline-block;
    @media screen and (min-width: $desktop-width) {
      font-size: 11px;
      line-height: .91;
    }

    &.free-cancel {
      color: #439855;
      margin-bottom: 4px;
      position: relative;
      padding-left: 14px;
      display: inline-block;
      margin-bottom: 8px;
    }

    &.tax {
      color: #c3c3c3;
    }

    .icon {
      width: 12px;
      height: 8px;
      display: inline-block;
      position: absolute;
      left: -2px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .icon-check {
      background-image: url('../../../assets/svg/icon_check.svg');
    }
  }
</style>
